import React, {Fragment} from 'react';
import EligibilityTable from '../../../UI/DataTable/DataTable';
import Message from '../../../components/Message/Message';
import Button from '../../../UI/Button/Button';
import classes from './MemberEligibility.css';
import Spinner from '../../../UI/Spinner/Spinner';
import { RefreshIcon, ProcessingIcon, RefreshIconDisable} from '../../../UI/Icons/Icons';
import * as actions from '../../../store/actions/index';
import { connect } from 'react-redux';
import Modal from '../../../UI/Modal/Modal';
import MemberPortalInfo from '../../../components/MemberPortalInfo/MemberPortalInfo';
import RebuildCacheMyuhcPopUp from '../../../components/RebuildCache/RebuildCacheMyuhcPopUp';
import { getPortalNameForEligibilityScreen, maskSubscr, isPortalActive, isAccountDisabled, isAccountEnabled, isPortalDisabled } from '../../../shared/utility';
import { FEATURE_NOT_AVAILABLE_FOR_USER_MESSAGE } from '../../../shared/AdminToolMessages';

const memberEligibilityReadOnly = (props) => {

    const resultColumnMapping = [
        {dataField: 'portalDisplayName', text: 'Portal', sort: true},
        {dataField: 'rebuild',
            text: 'Rebuild',
            title:(cell, row, rowIndex, colIndex)=>{
                return rowIndex;
            },
            events: isAccountDisabled(props.memberData.essoData) ? null : {
                onClick: (e) => {
                    const row = memberPortalList[e.currentTarget.title]
                    if (isPortalDisabled(row.portalShortNm, props.disabledPortals))
                        return;
                    return props.isNullHSID || props.isHeadlessUser || row.portalShortNm === "UHCPR" ?alert(FEATURE_NOT_AVAILABLE_FOR_USER_MESSAGE):row.portalShortNm==='MYUHC'?props.viewRebuildModalHandler({...row, rebuild: null, view: null}):isPortalActive(props.portals, row.portalShortNm)?props.rebuildCache({...row, rebuild: null, view: null, uuid: props.healthSafeId, userName: props.memberData.essoData.userName}):null
                }
            },
            headerAlign:'center',
            align:'center',
            classes: isAccountDisabled(props.memberData.essoData) ? classes.DisableLinkCol : classes.LinkCol,
            headerClasses: classes.LinkHeader},
    ];

    if(props.memberData.memberPortalAttributeList == null){
        props.memberData.memberPortalAttributeList = [{"memberPortalId":0}]
    }

    let memberPortalList = props.memberData.memberPortalAttributeList?.map((portalRec, index) => {
        return {
            ...portalRec,
            id: index,
            portalDisplayName: getPortalNameForEligibilityScreen(portalRec.portalShortNm, props.sdkPortalList),
            portalShortNm: portalRec.portalShortNm,
            portalSubscriberId: portalRec.portalShortNm==="CAP" ? portalRec.portalSubscriberId: portalRec.portalSubscriberId ? maskSubscr(portalRec.portalSubscriberId) : '-',
            rebuild: portalRec.portalShortNm===props.cacheRebuildPortal?<ProcessingIcon/>:(isPortalActive(props.portals, portalRec.portalShortNm)&& !isPortalDisabled(portalRec.portalShortNm, props.disabledPortals))?<RefreshIcon/>:<RefreshIconDisable/>,
            isSdkPortal: props.sdkPortalList && props.sdkPortalList.find(o => o.portalShortName === portalRec.portalShortNm) ? true : false,
            eligibilityInfo: props.sdkPortalList && (props.sdkPortalList.find(o => o.portalShortName === portalRec.portalShortNm) && portalRec.portalEligibilityResponse != null) ? portalRec.portalEligibilityResponse.eligibilityInfo.map(p => <div>{JSON.stringify(p)}</div>) : 'NA',
            portalSpecificMemberId: portalRec.portalSpecificMemberId ? portalRec.portalSpecificMemberId : '-',
            portalPolicyNbr: portalRec.portalPolicyNbr ? portalRec.portalPolicyNbr : '-'
        }
    });
    
    let form = (
        <EligibilityTable
            data={memberPortalList}
            columns={resultColumnMapping}
            clicked={(data)=>{}}
        />
    );

    let addEligButton = props.isNullHSID || (props.isHeadlessUser)?
        <div style={{display:'flex', justifyContent:'center', padding:'20px 0 10px 0'}}>
            <Button id="delete" btnType="Search" clicked={()=>props.deleteAccount({provisionMemberId:props.provisionMemberId,uuid:props.healthSafeId,userName:props.memberData.essoData?.userName})} disabled={false}>Delete HSID</Button>
        </div>:null;

    let displayMessage = null;
    if(props.message) {
        displayMessage = <Message msgType={props.message.type} info={props.message} />
    }

    let mbrPrtlModal = (props.memberPortalData)? <Modal show={props.showModal} modalClosed={props.modalHandler}><MemberPortalInfo mbrPortalInfo={props.memberPortalData} memberData={props.memberData} idType={props.idType} isNullHSID={props.isNullHSID}/></Modal>: null;
    
    let rebuildModal = (!props.showRebuildMyuhcModal && props.rebuildProcessing)? (
                        <Modal show={props.rebuildProcessing}>
                            <Spinner/>
                        </Modal>
                        ):null;

    let myuhcRebuildModal = props.showRebuildMyuhcModal? (
                            <Modal show={props.showRebuildMyuhcModal} modalClosed={props.viewRebuildModalHandler}>
                                <RebuildCacheMyuhcPopUp 
                                    mbrPortalInfo={props.memberPortalData} 
                                    modalClosed={props.viewRebuildModalHandler} 
                                    rebuildCache={props.rebuildCache}
                                    uuid={props.healthSafeId}
                                    userName={props.memberData.essoData.userName}
                                />
                            </Modal>
                        ):null;

    return (
        <Fragment>
            {mbrPrtlModal}
            {rebuildModal}
            {myuhcRebuildModal}
            {displayMessage}
            <div className={classes.EilgibilityHeader}>
                <div className={classes.EligibilityHeaderLeftEndDiv}></div>
                <h3 className={classes.EligibilityTitle}>{"Member Portal Eligibility"}</h3>
            </div>
            <div className={classes.EligibilityWrapper}>
                {form}
                {/* {addEligButton} */}
            </div>
        </Fragment>
    );
}

const mapStateToProps = state => {
    return {
        message: state.member.memberEligMsg,
        healthSafeId: state.member.member.healthSafeId,
        cacheRebuildPortal: state.member.rebuildCachePortal,
        memberPortals: state.member.member.memberPortalAttributeList,
        provisionMemberId: state.member.member.provisionMemberId,
        processing: state.member.processing,
        rebuildProcessing: state.member.rebuildProcessing,
        user: state.usr.user,
        portals: state.personalInfo.portals,
        disabledPortals: state.addEligibility.disabledPortals
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        rebuildCache: (memberPortalData) => dispatch(actions.rebuildCache(memberPortalData)),
        deleteAccount: (formData) => dispatch(actions.deleteAccount(formData, ownProps.history, "/search")),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(memberEligibilityReadOnly);